import { GET_TIPOS_PARTIDA, ADD_TIPO_PARTIDA, MODIFY_TIPO_PARTIDA, DELETE_TIPO_PARTIDA, UPDATE_TIPOS_PARTIDA } from '../constants/action_types';

const initialState = {
    tipospartida: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPOS_PARTIDA:
        
            return {
                tipospartida: [],
                isLoading: true
            };

        case GET_TIPOS_PARTIDA + "_SUCCESS":
        
            return {
                tipospartida: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_PARTIDA:

            const newArr = [...state.tipospartida, action.payload]
            return {
                tipospartida: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_PARTIDA:

           return {
                tipospartida: state.tipospartida.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };
        case DELETE_TIPO_PARTIDA:

            return {
                tipospartida: state.tipospartida.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPOS_PARTIDA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}